import './PanelItem.css';
import React from 'react';
import RouterLink from '../../atoms/RouterLink';
var PanelItemContent = function PanelItemContent(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "panel-item__icon",
    "aria-hidden": true,
    dangerouslySetInnerHTML: {
      __html: item.svgIcon
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "panel-item__text"
  }, item.text));
};
var PanelItem = function PanelItem(_ref2) {
  var item = _ref2.item;
  if (!item.href) {
    return /*#__PURE__*/React.createElement("button", {
      onClick: item.onClick,
      className: "".concat(commonStyles, " ").concat(item.highlighted ? "".concat(commonStyles, "__highlighted") : "")
    }, /*#__PURE__*/React.createElement(PanelItemContent, {
      item: item
    }));
  } else {
    return /*#__PURE__*/React.createElement(RouterLink, {
      href: item.href,
      onClick: item.onClick,
      className: "".concat(commonStyles, " ").concat(item.highlighted ? "".concat(commonStyles, "__highlighted") : "")
    }, /*#__PURE__*/React.createElement(PanelItemContent, {
      item: item
    }));
  }
};
export default PanelItem;
var commonStyles = "c1fl31ls";